import { useState, useEffect } from "react";
import supabase from '../supabaseClient';
import { sbCambiarPasswordFree, sbActualizarLogoFree } from '../services/free-api';
import { Inp, ModalAviso } from './ui/FormControls';

// ── PLAN FREE: Mi cuenta (info, contraseña, logo, upgrade) ────────
export const FreeAjustesSection = () => {
  const [cuenta, setCuenta] = useState(null);
  const [email, setEmail] = useState("");
  const [cargando, setCargando] = useState(true);

  const [nuevaPassword, setNuevaPassword] = useState("");
  const [confirmarPassword, setConfirmarPassword] = useState("");
  const [guardandoPassword, setGuardandoPassword] = useState(false);
  const [mensajePassword, setMensajePassword] = useState("");

  const [subiendoLogo, setSubiendoLogo] = useState(false);
  const [mensajeLogo, setMensajeLogo] = useState("");
  const [logoVersion, setLogoVersion] = useState(0);

  const [modalUpgrade, setModalUpgrade] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        const user = session?.user;
        if (!user) return;
        setEmail(user.email || "");
        const { data } = await supabase.from('cuentas').select('nombre_empresa, logo_url, created_at').eq('user_id', user.id).maybeSingle();
        setCuenta(data);
      } finally {
        setCargando(false);
      }
    };
    cargar();
  }, []);

  const cambiarPassword = async () => {
    setMensajePassword("");
    if (nuevaPassword.length < 8) {
      setMensajePassword("❌ La contraseña debe tener al menos 8 caracteres.");
      return;
    }
    if (nuevaPassword !== confirmarPassword) {
      setMensajePassword("❌ Las contraseñas no coinciden.");
      return;
    }
    setGuardandoPassword(true);
    try {
      await sbCambiarPasswordFree(nuevaPassword);
      setMensajePassword("✅ Contraseña actualizada correctamente.");
      setNuevaPassword("");
      setConfirmarPassword("");
    } catch (e) {
      setMensajePassword(`❌ ${e.message || "Error al actualizar la contraseña."}`);
    }
    setGuardandoPassword(false);
  };

  const subirLogo = async (file) => {
    if (!file) return;
    setSubiendoLogo(true);
    setMensajeLogo("");
    try {
      const { data: { session } } = await supabase.auth.getSession();
      const user = session?.user;
      if (!user) throw new Error("Sesión no válida, vuelve a iniciar sesión.");
      const filePath = `${user.id}/logo.png`;
      const { error: uploadError } = await supabase.storage.from('logos-empresa').upload(filePath, file, { upsert: true, contentType: file.type });
      if (uploadError) throw uploadError;
      const { data: { publicUrl } } = supabase.storage.from('logos-empresa').getPublicUrl(filePath);
      await sbActualizarLogoFree(publicUrl);
      setCuenta(c => ({ ...c, logo_url: publicUrl }));
      setLogoVersion(v => v + 1);
      setMensajeLogo("✅ Logo actualizado.");
    } catch (e) {
      setMensajeLogo(`❌ ${e.message || "Error al subir el logo."}`);
    }
    setSubiendoLogo(false);
  };

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-xl shadow p-4 space-y-3">
        <h2 className="font-bold text-gray-800 border-b pb-2">Mi cuenta</h2>
        {cargando ? (
          <p className="text-sm text-gray-400">Cargando...</p>
        ) : (
          <div className="grid grid-cols-2 gap-3 text-sm">
            <div>
              <p className="text-xs font-semibold text-gray-500 uppercase">Empresa</p>
              <p className="text-gray-800 mt-0.5">{cuenta?.nombre_empresa || "—"}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-500 uppercase">Email de acceso</p>
              <p className="text-gray-800 mt-0.5">{email || "—"}</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-500 uppercase">Plan actual</p>
              <p className="text-gray-800 mt-0.5">🆓 FREE</p>
            </div>
            <div>
              <p className="text-xs font-semibold text-gray-500 uppercase">Fecha de alta</p>
              <p className="text-gray-800 mt-0.5">{cuenta?.created_at ? new Date(cuenta.created_at).toLocaleDateString("es-ES") : "—"}</p>
            </div>
          </div>
        )}
      </div>

      <div className="bg-white rounded-xl shadow p-4 space-y-3">
        <h2 className="font-bold text-gray-800 border-b pb-2">Cambiar contraseña</h2>
        <Inp label="Nueva contraseña" type="password" value={nuevaPassword} onChange={setNuevaPassword} placeholder="Mínimo 8 caracteres" />
        <Inp label="Confirmar contraseña" type="password" value={confirmarPassword} onChange={setConfirmarPassword} placeholder="Repite la contraseña" />
        {mensajePassword && <p className={`text-sm font-semibold text-center ${mensajePassword.startsWith("✅") ? "text-green-600" : "text-red-500"}`}>{mensajePassword}</p>}
        <button onClick={cambiarPassword} disabled={guardandoPassword} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 disabled:opacity-40 transition-all">
          {guardandoPassword ? "Guardando..." : "Guardar contraseña"}
        </button>
      </div>

      <div className="bg-white rounded-xl shadow p-4 space-y-3">
        <h2 className="font-bold text-gray-800 border-b pb-2">Logo de empresa</h2>
        <div className="flex items-center gap-4">
          {cuenta?.logo_url ? (
            <img src={`${cuenta.logo_url}?v=${logoVersion}`} alt="Logo" className="w-20 h-20 object-contain border rounded-lg bg-gray-50" />
          ) : (
            <div className="w-20 h-20 flex items-center justify-center border rounded-lg bg-gray-50 text-gray-300 text-[10px] text-center px-1">Sin logo</div>
          )}
          <div className="flex-1">
            <input type="file" accept="image/*" disabled={subiendoLogo} onChange={e => subirLogo(e.target.files[0])} className="text-xs text-gray-600" />
            {subiendoLogo && <p className="text-xs text-gray-400 mt-1">Subiendo...</p>}
          </div>
        </div>
        {mensajeLogo && <p className={`text-sm font-semibold text-center ${mensajeLogo.startsWith("✅") ? "text-green-600" : "text-red-500"}`}>{mensajeLogo}</p>}
      </div>

      <div className="bg-white rounded-xl shadow p-4 space-y-3 text-center">
        <h2 className="font-bold text-gray-800">¿Necesitas más?</h2>
        <p className="text-sm text-gray-500">Inventario, archivo en la nube, alertas por email y descargas ilimitadas con PAIDmini.</p>
        <button onClick={() => setModalUpgrade(true)} className="w-full bg-gray-900 text-white font-bold py-3 rounded-xl hover:bg-gray-800 transition-all">
          Mejorar a PAIDmini
        </button>
      </div>

      <ModalAviso
        visible={modalUpgrade}
        icono="🚀"
        titulo="Próximamente"
        mensaje="PAIDmini está en construcción. Muy pronto podrás mejorar tu plan desde aquí."
        onClose={() => setModalUpgrade(false)}
      />
    </div>
  );
};
